import { Component, input } from '@angular/core';
import { selectButonInputImports, SelectButtonInputComponent } from './select-button-input.component';

@Component({
    selector: 'app-select-button-sex-input',
    templateUrl: './select-button-input.component.html',
    imports: selectButonInputImports,
})
export class SelectButtonSexInputComponent extends SelectButtonInputComponent {

    public override id = input<string, string | number>('sex', { transform: v => String(v) });

    public override options = input<{ key: string, value: string }[]>(
        [
            {
                key: 'male',
                value: 'male',
            },
            {
                key: 'female',
                value: 'female',
            },
        ],
    );
}
